import { render, staticRenderFns } from "./Shift.vue?vue&type=template&id=31d9ff3d&"
import script from "./Shift.vue?vue&type=script&lang=ts&"
export * from "./Shift.vue?vue&type=script&lang=ts&"
import style0 from "./Shift.vue?vue&type=style&index=0&id=31d9ff3d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports